import React, { useEffect, useState, useRef } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';

import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectItemPriceListData } from '../../Selectors/Master/ItemSelectors';
import { fetchItemPriceListData } from '../../../Store/PHPSlice/Item';
import ReactToPrint from 'react-to-print';
import { Delete, Preview } from '@mui/icons-material';
import axios from 'axios';
const thStyle = {
  border: '2px solid #000',
  padding: '2px',
  fontWeight: '700',
  color: 'red',
  background: '#fff'
};

const tdStyle = {
  border: '1px solid #000',
  padding: '2px',
  fontWeight: '600'
};

const leftTdStyle = {
  ...tdStyle,
  textAlign: 'left',
  color: '#0a7c9b'
};

const PriceListView = () => {
  const componentRef = useRef(); // Ref for the component to be printed
  const userdata = JSON.parse(localStorage.getItem('user'));
  const { Id, cat } = useParams();
  const [material, setMaterial] = useState([]);
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const materialData = useSelector(selectItemPriceListData);
  //  const itemSize = useSelector(selectItems);
  const [size, setSize] = useState([]);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    dispatch(fetchItemPriceListData({ id: Id, cat }));
    //  dispatch(fetchItemData(Id));
  }, [dispatch, Id, cat]);

  useEffect(() => {
    if (materialData?.data?.length > 0) {
      const data = materialData?.data;
      setMaterial(data);
      setFormData({ itemNm: materialData.itemNm }); // 👈 header-level
    }
  }, [materialData]);

  // useEffect(() => {
  //     if (itemSize?.data?.length > 0) {
  //         // const item = itemSize.data[0];
  //         // const sizeStr = item?.size || '';
  //         // const arr = sizeStr ? sizeStr.split(',') : [];
  //         // setSize(arr);
  //         const item = itemSize.data[0];
  //         const sizeStr = item?.size || '';
  //         const arr = sizeStr.split(',').map(s => s.trim());
  //         setSize(arr);
  //     } else {
  //         setSize([]);
  //     }
  // }, [itemSize]);

  useEffect(() => {
    if (material.length) {
      const sizes = new Set();
      material.forEach(m =>
        m.sizewise?.forEach(s => sizes.add(s.size))
      );
      setSize([...sizes]);
    }
  }, [material]);
  // console.log(material)

  const handleSizeWiseView = (id) => {
    window.open(`/sizewise-material-view/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
  };

  const handleDelete = async (itemId, clothNm, userId) => {
    try {
      const response = await axios.post(`${baseUrl}?apicall=DeleteItemPriceListItemIdClothNmWise&itemId=${itemId}&clothNm=${clothNm}&userId=${userId}`);

      if (response.data.status === 'success') {
        alert(response.data.msg);
        window.location.reload();
      } else {
        alert(response.data.msg || 'Delete failed');
      }

    } catch (error) {
      console.error(error);
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <>

      <div style={{ margin: '1% 0.5%' }}>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper style={{ padding: '2vh' }} ref={componentRef}>

              <h3 className='centered-heading'>Item Wise Price List ( <label style={{ color: "#f00" }}>{cat}</label> ) </h3>
              <div className="dashed-line"></div>

              <div style={{ overflowX: 'auto' }}>
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    textAlign: 'center',
                    lineHeight: '1'
                  }}
                >
                  <thead>
                    <tr>
                      <th style={thStyle}>
                        {formData?.itemNm} (size)
                      </th>

                      {size.map((sz, idx) => (
                        <th key={idx} style={thStyle}>
                          {sz}
                        </th>
                      ))}
                      <th style={thStyle} className="no-print">Delete</th>
                    </tr>
                  </thead>

                  <tbody>
                    {material.map((mat, index) => (
                      <tr key={index}>
                        <td style={leftTdStyle}>
                          {mat.materialNm}
                        </td>

                        {size.map((sz, sidx) => {
                          const matched = mat.sizewise?.find(
                            sw => String(sw.size) === String(sz)
                          );

                          return (
                            <td key={sidx} style={tdStyle}>
                              {matched ? matched.price ?? matched.matsize ?? matched.qty : '-'}
                            </td>
                          );
                        })}
                        <td className="no-print">

                          <Delete
                            className='cursor-pointer'
                            sx={{ fontSize: 18, m: 0, p: 0 }}
                            onClick={() => handleDelete(Id, mat.materialNm, userdata?.ID)}

                          />

                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>





              <div
                className="no-print"
                style={{ textAlign: 'center', marginTop: '20px' }}
              >
                <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                  <ReactToPrint
                    trigger={() => <Button variant="contained" color="primary">Print</Button>}
                    content={() => componentRef.current}
                  />
                </div>
              </div>

            </Paper>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default PriceListView;
